export const translations = {
  en: {
    brand: "Al Omarah",
    tagline: "Trading · Construction · Contracting",
    nav: {
      home: "Home",
      shop: "Shop",
      categories: "Categories",
      services: "Services",
      projects: "Project Enquiry",
      jobs: "Jobs",
      talent: "Talent Pool",
      about: "About",
      contact: "Contact",
      cart: "Cart",
      login: "Sign In",
      register: "Create Account",
      logout: "Sign Out",
      myOrders: "My Orders",
      admin: "Admin",
      account: "Account",
    },
    home: {
      kicker: "Qatar's trusted trading & contracting partner since 1998",
      heroTitle: "Building materials, hardware, and full-service contracting under one roof.",
      heroSub: "From plumbing networks and sanitary fittings to complete building construction & contracting — sourced, built, and delivered across Qatar.",
      shopNow: "Shop catalog",
      browseCategories: "Browse categories",
      featured: "Featured stock",
      stats: {
        products: "SKUs in stock",
        years: "Years in trade",
        delivery: "Same-day Doha delivery",
        brands: "Global brands",
      },
      whyTitle: "Why builders choose Al Omarah",
      why1Title: "Verified inventory",
      why1: "Live stock from our Doha warehouse — no surprises at the counter.",
      why2Title: "Turnkey contracting",
      why2: "From foundation to handover — civil, MEP, and finishing crews on call.",
      why3Title: "Logistics built-in",
      why3: "Heavy-duty fleet ready for jobsite drops across Qatar.",
      ctaTitle: "Need a project quote?",
      ctaSub: "Send us your BOQ and we'll match it from stock or build it from scratch.",
      ctaBtn: "Submit project enquiry",
      servicesTitle: "Services",
      services: {
        trading: { t: "Trading & Supply", d: "16+ stocked categories, branded inventory, fleet delivery." },
        contracting: { t: "Construction & Contracting", d: "Civil, MEP, and finishing for residential, commercial, industrial." },
        projects: { t: "Project Enquiry", d: "Submit your BOQ for a tailored quote and timeline." },
        jobs: { t: "Skilled Jobs", d: "Open positions for foremen, plumbers, electricians, masons." },
        talent: { t: "Talent Pool", d: "Qualified workers available — register or hire from our pool." },
      },
    },
    categories: {
      plumbing: "Plumbing",
      sanitary: "Sanitary Ware",
      hardware: "Hardware",
      building: "Building Materials",
    },
    shop: {
      title: "Shop", search: "Search products, SKU, brand…", all: "All", sortBy: "Sort by",
      featured: "Featured", priceLow: "Price: Low to High", priceHigh: "Price: High to Low",
      empty: "No products match.", addToCart: "Add to cart", sku: "SKU", stock: "In stock", out: "Out of stock",
    },
    product: { back: "Back to shop", qty: "Quantity", brand: "Brand", buyNow: "Buy now", added: "Added to cart" },
    cart: { title: "Cart", empty: "Your cart is empty.", shopNow: "Continue shopping", subtotal: "Subtotal", total: "Total", checkout: "Proceed to checkout", remove: "Remove" },
    checkout: {
      title: "Checkout", shipping: "Delivery details", fullName: "Full name", phone: "Phone",
      addressLine: "Address", city: "City", area: "Area / Zone", notes: "Order notes (optional)",
      paymentMethod: "Payment method", cod: "Cash on delivery", stripe: "Pay online (card)",
      placeOrder: "Place order", processing: "Processing…", orderTotal: "Order total",
      mustLogin: "Please sign in to continue.",
    },
    auth: {
      loginTitle: "Sign in to Al Omarah", registerTitle: "Create your account",
      email: "Email", password: "Password", name: "Full name", phone: "Phone",
      submit: "Continue", noAccount: "New here?", haveAccount: "Already have an account?",
      signupCta: "Create an account", signinCta: "Sign in",
    },
    orders: { title: "My orders", empty: "You haven't placed any orders yet.", orderId: "Order", placed: "Placed", status: "Status", payment: "Payment", total: "Total", items: "Items" },
    admin: {
      title: "Admin Dashboard",
      products: "Products", orders: "Orders", inquiries: "Inquiries", jobs: "Jobs", candidates: "Talent", applications: "Applications",
      addProduct: "Add product", editProduct: "Edit product",
      addJob: "Add job", editJob: "Edit job",
      save: "Save", cancel: "Cancel", delete: "Delete",
      confirmDelete: "Delete this item?", orderUpdated: "Order updated",
    },
    common: { currency: "QAR", loading: "Loading…", submit: "Submit", required: "Required" },
    payment: {
      checking: "Verifying your payment…", success: "Payment successful",
      successMsg: "Your order has been confirmed. Thank you!", failed: "Payment failed or expired",
      pending: "Payment is being processed", timeout: "We couldn't verify the payment in time.",
      goOrders: "View my orders",
    },
    inquiry: {
      title: "Project Enquiry",
      subtitle: "Share your construction project. We'll respond within one business day.",
      companyName: "Company name", contactName: "Contact person", projectType: "Project type",
      types: { residential: "Residential", commercial: "Commercial", industrial: "Industrial", renovation: "Renovation", other: "Other" },
      location: "Project location", scope: "Scope of work / BOQ summary",
      timeline: "Expected timeline", budget: "Budget range (QAR)",
      submit: "Submit enquiry", success: "Thank you! Our team will reach out shortly.",
    },
    jobs: {
      title: "Skilled Employees Required",
      subtitle: "Open positions across Qatar construction sites — apply directly.",
      empty: "No open positions right now.",
      apply: "Apply now", years: "yrs", experience: "Experience required",
      salary: "Salary (QAR)", location: "Location",
      applyTitle: "Apply for", coverNote: "Cover note (optional)",
      yearsExp: "Your years of experience",
      submitApp: "Submit application", appSuccess: "Application received. We'll be in touch.",
      trades: { mason: "Mason", plumber: "Plumber", electrician: "Electrician", foreman: "Foreman", carpenter: "Carpenter", painter: "Painter", hvac: "HVAC", helper: "Helper", other: "Other" },
    },
    talent: {
      title: "Skilled Employees Available",
      subtitle: "Verified tradespeople available for hire across Qatar. Register your profile or browse the pool.",
      register: "Register your profile",
      browse: "Browse talent",
      empty: "No candidates listed yet.",
      registerTitle: "Register as available talent",
      trade: "Primary trade", years: "Years of experience", nationality: "Nationality",
      availability: "Availability", availabilityOpts: { immediate: "Immediate", "within-2-weeks": "Within 2 weeks", "within-1-month": "Within 1 month" },
      bio: "Short bio (skills, certifications)", submit: "Submit profile",
      success: "You're on the list. Hiring teams may reach out.",
      filterTrade: "Filter by trade",
      hireContact: "Contact details visible to verified hiring partners only.",
    },
    footer: { rights: "All rights reserved.", address: "Doha, Qatar" },
    contact: {
      title: "Get in touch",
      subtitle: "Drop us a line for orders, contracting quotes, or partnership.",
      website: "Website", email: "Email", phone: "Phone", whatsapp: "WhatsApp us",
      address: "Doha, Qatar",
      followUs: "Follow us",
    },
    dropship: {
      title: "Dropship Import",
      sub: "Re-list a supplier product with auto markup.",
      source: "Source", url: "Supplier URL", supplierSku: "Supplier SKU",
      originalPrice: "Original price", currency: "Currency", fx: "FX to QAR",
      markup: "Markup %", leadTime: "Lead time (days)", stock: "Stock",
      computedQar: "Computed cost (QAR)", computedSale: "Sale price (QAR)",
      sources: { aliexpress: "AliExpress", alibaba: "Alibaba", alidrop: "AliDrop", cj: "CJ Dropshipping", spocket: "Spocket", dsers: "DSers", banggood: "Banggood", other: "Other" },
      import: "Import as product",
      success: "Imported into catalog",
    },
  },
  ar: {
    brand: "العمارة",
    tagline: "تجارة · إنشاءات · مقاولات",
    nav: {
      home: "الرئيسية", shop: "المتجر", categories: "الفئات", services: "الخدمات",
      projects: "طلب مشروع", jobs: "وظائف", talent: "العمالة المتاحة",
      about: "عن الشركة", contact: "تواصل", cart: "السلة",
      login: "تسجيل الدخول", register: "إنشاء حساب", logout: "تسجيل الخروج",
      myOrders: "طلباتي", admin: "الإدارة", account: "الحساب",
    },
    home: {
      kicker: "شريك التجارة والمقاولات الموثوق في قطر منذ 1998",
      heroTitle: "مواد بناء وأجهزة وخدمات مقاولات متكاملة تحت سقف واحد.",
      heroSub: "من شبكات السباكة والتركيبات الصحية إلى البناء الكامل والمقاولات — توفير وتنفيذ وتسليم في جميع أنحاء قطر.",
      shopNow: "تسوق الآن", browseCategories: "تصفح الفئات", featured: "منتجات مميزة",
      stats: { products: "منتج في المخزون", years: "عام في التجارة", delivery: "توصيل في نفس اليوم", brands: "علامة تجارية عالمية" },
      whyTitle: "لماذا يختارنا المقاولون",
      why1Title: "مخزون موثق", why1: "مخزون مباشر من مستودعنا في الدوحة — بدون مفاجآت.",
      why2Title: "مقاولات شاملة", why2: "من الأساسات إلى التسليم — طواقم مدنية وكهروميكانيكية وتشطيبات.",
      why3Title: "لوجستيات متكاملة", why3: "أسطول جاهز للتوصيل لمواقع المشاريع.",
      ctaTitle: "تحتاج عرض سعر لمشروع؟",
      ctaSub: "أرسل لنا قائمة الكميات وسنطابقها من المخزون أو ننفذها من الصفر.",
      ctaBtn: "تقديم طلب مشروع",
      servicesTitle: "خدماتنا",
      services: {
        trading: { t: "تجارة وتوريد", d: "أكثر من 16 فئة منتجات، علامات معتمدة، توصيل بأسطول خاص." },
        contracting: { t: "إنشاءات ومقاولات", d: "مدني وكهروميكانيكي وتشطيبات للسكني والتجاري والصناعي." },
        projects: { t: "طلب مشروع", d: "أرسل قائمة الكميات للحصول على عرض مخصص وجدول زمني." },
        jobs: { t: "وظائف ماهرة", d: "وظائف شاغرة لمشرفين وسباكين وكهربائيين وبنائين." },
        talent: { t: "العمالة المتاحة", d: "عمالة مؤهلة متوفرة — سجّل أو وظّف من قاعدتنا." },
      },
    },
    categories: { plumbing: "السباكة", sanitary: "الأدوات الصحية", hardware: "الأجهزة والعدد", building: "مواد البناء" },
    shop: {
      title: "المتجر", search: "ابحث عن منتج أو رقم تعريفي…", all: "الكل", sortBy: "ترتيب حسب",
      featured: "المميز", priceLow: "السعر: من الأقل للأعلى", priceHigh: "السعر: من الأعلى للأقل",
      empty: "لا توجد منتجات مطابقة.", addToCart: "أضف إلى السلة", sku: "الرمز", stock: "متوفر", out: "غير متوفر",
    },
    product: { back: "العودة للمتجر", qty: "الكمية", brand: "الماركة", buyNow: "اشتر الآن", added: "تمت الإضافة للسلة" },
    cart: { title: "السلة", empty: "سلتك فارغة.", shopNow: "تابع التسوق", subtotal: "المجموع الفرعي", total: "الإجمالي", checkout: "المتابعة للدفع", remove: "إزالة" },
    checkout: {
      title: "إتمام الشراء", shipping: "تفاصيل التوصيل", fullName: "الاسم الكامل", phone: "الهاتف",
      addressLine: "العنوان", city: "المدينة", area: "المنطقة", notes: "ملاحظات الطلب (اختياري)",
      paymentMethod: "طريقة الدفع", cod: "الدفع عند الاستلام", stripe: "الدفع الإلكتروني (بطاقة)",
      placeOrder: "تأكيد الطلب", processing: "جاري المعالجة…", orderTotal: "إجمالي الطلب",
      mustLogin: "يرجى تسجيل الدخول للمتابعة.",
    },
    auth: {
      loginTitle: "تسجيل الدخول", registerTitle: "إنشاء حساب جديد",
      email: "البريد الإلكتروني", password: "كلمة المرور", name: "الاسم الكامل", phone: "الهاتف",
      submit: "متابعة", noAccount: "ليس لديك حساب؟", haveAccount: "لديك حساب بالفعل؟",
      signupCta: "إنشاء حساب", signinCta: "تسجيل الدخول",
    },
    orders: { title: "طلباتي", empty: "لم تقم بأي طلب بعد.", orderId: "رقم الطلب", placed: "التاريخ", status: "الحالة", payment: "الدفع", total: "الإجمالي", items: "العناصر" },
    admin: {
      title: "لوحة الإدارة",
      products: "المنتجات", orders: "الطلبات", inquiries: "طلبات المشاريع", jobs: "الوظائف", candidates: "العمالة", applications: "التقديمات",
      addProduct: "إضافة منتج", editProduct: "تعديل المنتج",
      addJob: "إضافة وظيفة", editJob: "تعديل الوظيفة",
      save: "حفظ", cancel: "إلغاء", delete: "حذف",
      confirmDelete: "هل تريد الحذف؟", orderUpdated: "تم التحديث",
    },
    common: { currency: "ر.ق", loading: "جاري التحميل…", submit: "إرسال", required: "إلزامي" },
    payment: {
      checking: "جاري التحقق من الدفع…", success: "تم الدفع بنجاح",
      successMsg: "تم تأكيد طلبك. شكرًا لك!", failed: "فشل الدفع أو انتهت الجلسة",
      pending: "جاري معالجة الدفع", timeout: "تعذر التحقق من الدفع في الوقت المناسب.",
      goOrders: "عرض طلباتي",
    },
    inquiry: {
      title: "طلب مشروع",
      subtitle: "شاركنا تفاصيل مشروعك الإنشائي. سنرد خلال يوم عمل واحد.",
      companyName: "اسم الشركة", contactName: "اسم المسؤول", projectType: "نوع المشروع",
      types: { residential: "سكني", commercial: "تجاري", industrial: "صناعي", renovation: "ترميم", other: "أخرى" },
      location: "موقع المشروع", scope: "نطاق العمل / ملخص قائمة الكميات",
      timeline: "الإطار الزمني المتوقع", budget: "نطاق الميزانية (ر.ق)",
      submit: "إرسال الطلب", success: "شكرًا لك! سيتواصل فريقنا معك قريبًا.",
    },
    jobs: {
      title: "العمالة الماهرة المطلوبة",
      subtitle: "وظائف شاغرة في مواقع البناء بقطر — قدّم مباشرة.",
      empty: "لا توجد وظائف شاغرة حاليًا.",
      apply: "قدّم الآن", years: "سنوات", experience: "الخبرة المطلوبة",
      salary: "الراتب (ر.ق)", location: "الموقع",
      applyTitle: "تقديم على", coverNote: "نبذة (اختياري)",
      yearsExp: "سنوات خبرتك",
      submitApp: "إرسال الطلب", appSuccess: "تم استلام طلبك. سنتواصل معك.",
      trades: { mason: "بنّاء", plumber: "سبّاك", electrician: "كهربائي", foreman: "مشرف", carpenter: "نجار", painter: "دهّان", hvac: "تكييف", helper: "مساعد", other: "أخرى" },
    },
    talent: {
      title: "العمالة الماهرة المتاحة",
      subtitle: "عمالة مؤهلة متوفرة للتوظيف في قطر. سجّل ملفك أو تصفّح القائمة.",
      register: "سجّل ملفك", browse: "تصفّح",
      empty: "لا توجد ملفات مسجلة بعد.",
      registerTitle: "سجّل كعامل متاح",
      trade: "المهنة الأساسية", years: "سنوات الخبرة", nationality: "الجنسية",
      availability: "التوفر", availabilityOpts: { immediate: "فوري", "within-2-weeks": "خلال أسبوعين", "within-1-month": "خلال شهر" },
      bio: "نبذة قصيرة (مهارات وشهادات)", submit: "إرسال الملف",
      success: "تم تسجيلك. قد تتواصل معك جهات التوظيف.",
      filterTrade: "تصفية حسب المهنة",
      hireContact: "تفاصيل الاتصال متاحة للجهات الموثقة فقط.",
    },
    footer: { rights: "جميع الحقوق محفوظة.", address: "الدوحة، قطر" },
    contact: {
      title: "تواصل معنا",
      subtitle: "للطلبات وعروض المقاولات والشراكات.",
      website: "الموقع", email: "البريد", phone: "الهاتف", whatsapp: "واتساب",
      address: "الدوحة، قطر",
      followUs: "تابعنا",
    },
    dropship: {
      title: "استيراد دروبشيب",
      sub: "إعادة عرض منتج مورد مع هامش ربح تلقائي.",
      source: "المصدر", url: "رابط المورد", supplierSku: "رقم المورد",
      originalPrice: "السعر الأصلي", currency: "العملة", fx: "سعر الصرف للريال",
      markup: "هامش %", leadTime: "مدة التوريد (أيام)", stock: "المخزون",
      computedQar: "التكلفة (ر.ق)", computedSale: "سعر البيع (ر.ق)",
      sources: { aliexpress: "AliExpress", alibaba: "Alibaba", alidrop: "AliDrop", cj: "CJ Dropshipping", spocket: "Spocket", dsers: "DSers", banggood: "Banggood", other: "أخرى" },
      import: "استيراد كمنتج",
      success: "تم الاستيراد إلى الكتالوج",
    },
  },
};
